import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const PurchaseManagement = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Satın Alma Yönetimi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Satın alma yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default PurchaseManagement;
